// extracted by mini-css-extract-plugin
module.exports = {"account-edit-form":"AccountEditForm_account-edit-form__2i2DG","footer":"AccountEditForm_footer__17hkH"};